<template>
  <AppSheet
    mode="centered"
    :is-open="showPrePrompt"
    :backdrop-dismiss="true"
    @update:is-open="onUpdateOpen"
  >
    <div class="notif-permission-content flex flex-col items-center text-center px-6 pt-7 pb-6">
      <!-- Mascotte hibou -->
      <img
        src="/illustrations/hiboux/hibou_magicien_parle-optimized.webp"
        alt=""
        class="w-28 h-28 object-contain mb-3"
        draggable="false"
      />

      <h2 class="text-[20px] font-bold text-ink leading-tight">
        {{ t('validationReminder.permission.title') }}
      </h2>

      <p class="mt-2 text-[14px] leading-relaxed text-ink-2">
        {{ t('validationReminder.permission.rationale') }}
      </p>

      <!-- Aperçu de la notif (rend le bénéfice concret) -->
      <div class="mt-4 w-full rounded-2xl bg-warm-2 px-4 py-3 flex items-start gap-3 text-left">
        <IconTile icon="bell" :size="36" :icon-size="18" tone="joy" />
        <div class="min-w-0">
          <p class="text-[13px] font-semibold text-ink truncate">
            {{ t('validationReminder.permission.previewTitle') }}
          </p>
          <p class="text-[12px] text-ink-3 leading-snug">
            {{ t('validationReminder.permission.previewBody') }}
          </p>
        </div>
      </div>

      <div class="mt-5 w-full flex flex-col gap-2">
        <Button data-testid="reminder-permission-allow" class="w-full" @click="onAllow">
          {{ t('validationReminder.permission.allow') }}
        </Button>
        <button
          type="button"
          data-testid="reminder-permission-later"
          class="text-[14px] text-ink-3 py-2 active:opacity-70"
          @click="onLater"
        >
          {{ t('validationReminder.permission.later') }}
        </button>
      </div>
    </div>
  </AppSheet>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import AppSheet from '@/components/common/AppSheet.vue'
import IconTile from '@/components/common/IconTile.vue'
import { Button } from '@/components/ui/button'
import { useNotificationPermission } from '@/composables/useNotificationPermission'

const { t } = useI18n({ useScope: 'global' })
const { showPrePrompt, acceptPrePrompt, dismissPrePrompt } = useNotificationPermission()

function onAllow() {
  void acceptPrePrompt()
}

function onLater() {
  dismissPrePrompt()
}

// Backdrop / swipe dismiss = same as "Later" (re-showable, OS untouched).
function onUpdateOpen(open: boolean) {
  if (!open) dismissPrePrompt()
}
</script>

<!-- Non scopé : l'ion-modal est téléporté hors du composant. On cible UNIQUEMENT
     cette modale via :has(.notif-permission-content) pour ajuster la hauteur au
     contenu sans impacter les autres modales centered. -->
<style>
ion-modal.app-sheet.centered:has(.notif-permission-content) {
  --height: auto;
}
</style>
